// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.path-lookup-edge-tooltip {
  width: 260px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphTooltip/styles.css","webpack://./services/frontend/app/components/Graph/GraphTooltip/styles.css"],"names":[],"mappings":"AADA;ECEE,YAAY;AACd","sourcesContent":[".path-lookup-edge-tooltip {\n  width: 260px;\n}\n",".path-lookup-edge-tooltip {\n  width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
